import topic from '../topic'
export const crftAPI = {
    getCrfts: topic.crftTopic + '/get_crfts',
    getCrftById: topic.crftTopic + '/get_crft_by_id',
    addCrft: topic.crftTopic + '/add_crft',
    editCrft: topic.crftTopic + '/edit_crft',
    deleteCrftByIds: topic.crftTopic + '/delete_crft_by_ids'
}